import { useEffect, useState } from 'react';
import { ComposedChart, Bar, Legend, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

import { servGetGraficoDetalhamentoMetrica, servGetGraficoDetalhamentoEstabelecimento } from '../../../servicos/graficos_indicador';
import { formataOperadoresRelacionaisV2 } from '../../../util/utilitarios';

import Modal from 'react-bootstrap/Modal';
import fichaIcon from '../../../imagens/fichaIcon.png'

function ComposedChartDetalhamentoIndicador({ dadosGraf, estabelecimento }) {

    console.log('### Iniciando ComposedChartDetalhamentoIndicadorOuEstabelecimento ###');

    let todosOsMeses = new Set();

    dadosGraf.forEach(metrica => {
        metrica.indicadores.forEach(indicador => {
            todosOsMeses.add(indicador.mesReferenciaFormatado);
        });
    });

    todosOsMeses = Array.from(todosOsMeses)

    dadosGraf = dadosGraf.map(metrica => {
        const indicadoresPorMes = new Map(
            metrica.indicadores.map(ind => [ind.mesReferenciaFormatado, ind])
        );

        const indicadoresCompletos = todosOsMeses.map(mes => {
            const encontrado = indicadoresPorMes.get(mes);

            return encontrado || {
                Meta: metrica.metaNumero,
                Resultado: null,
                indicadorId: null,
                mesReferenciaFormatado: mes,
                metaOperador: metrica.metaOperador,
                metricaMeta: `${metrica.metaOperador}${metrica.metaNumero}%`,
                resultadoEmPorcentagem: metrica.resultadoEmPorcentagem ? 1 : 0,
                semDados: true,
            };
        });

        return { ...metrica, indicadores: indicadoresCompletos };
    });

    const [exibeFichaIndicador, setExibeFichaIndicador] = useState(null)

    const calculaLimitesEixosGraf = (dataMin, dataMax) => {

        const maxY = (Math.round(dataMax / 5) * 5);
        const minX = (Math.round(dataMin / 5) * 5);

        let retornoEixoY = null
        let retornoEixoX = null

        // Calculando dataMin
        if (minX < 0) {
            retornoEixoX = minX - 20;
        } else {
            retornoEixoX = 0;
        }

        // Calculando dataMax
        if (maxY < 20) {
            retornoEixoY = maxY + 10;
        } else if (maxY < 110 && maxY > 40) {
            retornoEixoY = 100;
        } else {
            retornoEixoY = maxY + 30;
        }

        return [retornoEixoX, retornoEixoY];
    }

    const CustomTooltip = ({ payload, label, active }) => {
        if (active && payload && payload.length) {


            const mesReferenciaFormatado = payload[0]?.payload?.mesReferenciaFormatado
            const resultado = payload[0]?.payload?.Resultado ?? 'Sem resultado'
            const metaNumero = payload[0]?.payload?.Meta
            const metaOperador = payload[0]?.payload?.metaOperador
            const resultadoEmPorcentagem = payload[0]?.payload?.resultadoEmPorcentagem

            return (
                <div style={{ background: "#fff", border: "1px solid #ccc", padding: 8 }}>
                    <p> {`Mês: ${mesReferenciaFormatado}`} </p>
                    <p style={{ color: "#4567a9" }} > {`Resultado: ${resultado}`}</p>
                    <p style={{ color: "#d64550" }} > {`Meta: ${formataOperadoresRelacionaisV2(metaNumero, metaOperador, resultadoEmPorcentagem)}`}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <div className=''>

            <Modal show={exibeFichaIndicador} size="lg" centered >
                <Modal.Header>
                    <Modal.Title className="fs-6">{exibeFichaIndicador?.metricaCodigo} - {exibeFichaIndicador?.metricaDescricao}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="p-3 d-flex flex-column gap-3">
                        <div>
                            {exibeFichaIndicador?.numerador &&
                                <p className='m-0'>
                                    <strong>
                                        Numerador:
                                    </strong> {" "}
                                    {exibeFichaIndicador?.numerador}
                                </p>
                            }
                            {exibeFichaIndicador?.denominador &&
                                <p className='m-0'>
                                    <strong>
                                        Denominador:
                                    </strong> {" "}
                                    {exibeFichaIndicador.denominador}
                                </p>
                            }
                        </div>
                        {exibeFichaIndicador?.metodoDeCalculo &&
                            <p className='m-0'>
                                <strong>
                                    Método de cálculo:
                                </strong> {" "}
                                <br />
                                {exibeFichaIndicador?.metodoDeCalculo}
                            </p>
                        }
                        <div>
                            {exibeFichaIndicador?.metricaFonte &&
                                <p className='m-0'>
                                    <strong>
                                        Fonte:
                                    </strong> {" "}
                                    {exibeFichaIndicador?.metricaFonte}
                                </p>
                            }
                            {exibeFichaIndicador?.metaNumero &&
                                <p className='m-0'>
                                    <strong>
                                        Meta:
                                    </strong> {" "}
                                    {
                                        formataOperadoresRelacionaisV2(
                                            exibeFichaIndicador?.metaNumero,
                                            exibeFichaIndicador?.metaOperador,
                                            exibeFichaIndicador?.resultadoEmPorcentagem
                                        )
                                    }
                                </p>
                            }
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-primary"
                        onClick={() => setExibeFichaIndicador(null)}
                    >
                        FECHAR
                    </button>
                </Modal.Footer>
            </Modal>

            <div className='text-center'>
                {estabelecimento && <p>Unidade Selecionada: <strong>{estabelecimento.nome}</strong></p>}
            </div>
            <div className='d-flex flex-column flex-md-row row justify-content-center'>
                {dadosGraf && (
                    dadosGraf.map((metrica, indice) => {
                        return (
                            <div key={metrica.metricaId} className='col-12 col-sm-6 mb-3' >
                                <div className='div-com-borda' style={{ width: '100%', height: '30em' }}>
                                    <div className='h-25 d-flex justify-content-center align-items-center text-center'>
                                        <div className='col-10 col-md-11'>
                                            <p className='m-0'>{metrica.metricaCodigo} - {metrica.metricaDescricao}</p>
                                        </div>
                                        <div className='col-2 col-md-1 div-cursor-pointed d-flex justify-content-center align-items-center'>
                                            <img
                                                className='fichaIcon'
                                                alt='icone para exibir ficha'
                                                src={fichaIcon} onClick={() => setExibeFichaIndicador(dadosGraf[indice])}
                                                style={{ width: '1.5em' }}
                                            />
                                        </div>
                                    </div>
                                    <ResponsiveContainer width="100%" height="60%">
                                        <ComposedChart
                                            margin={{ top: 30 }}
                                            data={metrica.indicadores}
                                        >
                                            <CartesianGrid stroke="#f5f5f5" />
                                            <XAxis
                                                dataKey="mesReferenciaFormatado"
                                                scale="auto"
                                                axisLine={false}
                                                label={false}
                                                fontSize={9}
                                            />
                                            <YAxis
                                                axisLine={false}
                                                fontSize={9}
                                                tickCount={8}
                                                domain={([dataMin, dataMax]) => {
                                                    return calculaLimitesEixosGraf(dataMin, dataMax);
                                                }}
                                            />
                                            <Tooltip content={<CustomTooltip />} />
                                            <Legend />
                                            <Bar
                                                dataKey="Resultado"
                                                fill="#4567a9"
                                                label={{ fill: "black", fontSize: 12, position: 'top', fontWeight: 'bold' }}
                                            />
                                            <Line
                                                type="auto"
                                                dataKey="Meta"
                                                stroke="#d64550"
                                                dot={false}
                                                strokeDasharray="3 3"
                                                strokeWidth={3}
                                                activeDot={false}
                                            />
                                        </ComposedChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        )
                    })
                )
                }
            </div>
        </div >
    )
}

export default ComposedChartDetalhamentoIndicador
